import { SpeakerImageUpload } from "./SpeakerImageUpload";

export default SpeakerImageUpload;
